export default [
  {
    path: '/dashboard',
    name: 'report-one',
    component: () => import('@/views/report/ecommerce/ReportOne.vue'),
   
  },
  // {
  //   path: '/dashboard02',
  //   name: 'report-two',
  //   component: () => import('@/views/report/ecommerce/ReportTwo.vue'),
    
  // },
]
